import "./BackWall.css";
function BackWall() {
  return (
    <>
      <div className="wall" />
    </>
  );
}
export default BackWall;
